module.exports = __webpack_public_path__ + "static/media/5DPO7.a6c2f2ba.jpg";